import type { TrackingDatasType } from '@libs/data-access/queries'
import { atom, useAtom } from 'jotai'

export type AtomTrackingDatasType = Partial<TrackingDatasType>

export const allowedTrackingDatasKeys = [
  'msclkid',
  'gclid',
  'referrer',
  'utm_campaign',
  'utm_content',
  'utm_medium',
  'utm_source',
  'utm_term',
  'medium',
  'source',
  'campaign',
  'ga_id'
]

export const atomTrackingDatas = atom<AtomTrackingDatasType>({})

export const useAtomTrackingDatas = () => {
  const atom = useAtom(atomTrackingDatas)

  return atom
}
